import React from 'react';
import { useNavigate } from 'react-router-dom';
import { XCircle } from 'lucide-react';
import { Button } from '../components/ui/button';

export default function PaymentCancel() {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-zinc-50 flex items-center justify-center">
      <div className="bg-white border border-zinc-200 p-8 max-w-md w-full text-center">
        <XCircle className="w-16 h-16 mx-auto text-zinc-400 mb-4" />
        <h1 className="text-2xl font-bold text-zinc-900 mb-2">Payment Cancelled</h1>
        <p className="text-zinc-600 mb-6">
          Your payment was cancelled. You can try again from your dashboard whenever you're ready.
        </p>
        <div className="space-y-3">
          <Button onClick={() => navigate('/org/dashboard')} className="w-full" data-testid="return-to-dashboard-btn">
            Return to Dashboard
          </Button>
          <Button onClick={() => navigate('/')} variant="outline" className="w-full">
            Go to Home
          </Button>
        </div>
      </div>
    </div>
  );
}
